import { FC } from 'react'

type IconTriangleDownProps = {
  className?: string
}

export const IconTriangleDown: FC<IconTriangleDownProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="12"
      viewBox="0 0 23 12"
      width="23"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8215 11.3732C11.2046 11.7271 11.7954 11.7271 12.1786 11.3732L22.6127 1.73455C23.2812 1.11698 22.8443 0 21.9341 0H1.06588C0.155746 0 -0.281212 1.11698 0.387328 1.73455L10.8215 11.3732Z"
        fill="#999999"
      />
    </svg>
  )
}
